import {Component} from '@angular/core';
import {ReporteServices} from '../../services/reporte.services';

@Component({
  selector:"indgeneral-widget",
  templateUrl:"../../templates/widgets/ind.general.widget.template.html"
})
export class IndGeneralWidgetComponent {

  mostrar:boolean = false;

  datosTabla:any = {};

  constructor(private rs: ReporteServices) {

  }

  consultar(entidad: number, idEntidad: string, fecha1: string, fecha2: string) {
    this.mostrar = false;
    this.rs.devolverReporteIndGeneral(entidad, idEntidad, fecha1, fecha2).subscribe(d=>{

      if(d.data.reporteIndGeneral){
        let data = JSON.parse(d.data.reporteIndGeneral);
        console.log(data);
        this.datosTabla = data;
        this.mostrar = true;
      }
    })
  }

}
